<div class="card" [ngClass]="cardType">
  <ng-content></ng-content>
</div>
